import classNames from 'classnames'
import type { ReactNode } from 'react'
import React, { memo } from 'react'

import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

import useStyles from './useStyles'
export interface Props {
  children?: ReactNode
  isLoading?: boolean
  overlayClassName?: string
  shouldHide?: boolean
}

function LoadingOverlay({ overlayClassName, children, isLoading = false, shouldHide = false }: Props) {
  const classes = useStyles()

  return (
    <Box aria-busy={isLoading} className={classNames(classes.root, { [classes.hidden]: shouldHide })} role="alert">
      <Box className={classes.loaderWrapper} display={isLoading ? 'flex' : 'none'}>
        <CircularProgress className={classes.loader} />
      </Box>
      <Box className={classNames(classes.overlay, overlayClassName)} display={isLoading ? 'block' : 'none'} />

      {children}
    </Box>
  )
}

export default memo<Props>(LoadingOverlay)
